// eslint-disable-next-line
import React, { Fragment } from 'react';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaHttpClientPrice } from '../../../code/ArcaHttpClientPrice';
import { StatusBar } from '../StatusBar';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';


export class ModifierPanel extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            modifiers: null,
            isError: false,
            message: null
        };
    }

    async componentDidMount() {
        ArcaHttpClientPrice.GetSurchargesAsync(
            (modifiers => this.setState({ modifiers })),
            (msg => this.setState({ isError: true, message: msg }))
        );
    }


    render() {

        let { modifiers, isError, message } = this.state;

        return (
            <Fragment>
                <h1 className='centerText'>Price modifiers</h1>
                <StatusBar message={message} isError={isError} />
                {modifiers
                    ? <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Description</th>
                                {!ArcaHttpSystem.IsSmartphone
                                    ? <th>Start date</th>
                                    : null}
                                <th>End date</th>
                                <th>Param.</th>
                                <th>Fact.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modifiers ? modifiers.map((m, k) =>
                                <tr key={k}>
                                    <td>{m.Description}</td>
                                    {!ArcaHttpSystem.IsSmartphone
                                        ? <td>{m.StartDate.ToDateString}</td>
                                        : null}
                                    <td>{m.EndDate.ToDateString}</td>
                                    <td>{m.Parameter}</td>
                                    <td>{m.Factor}</td>
                                </tr>
                            )
                                : null}
                        </tbody>
                    </table>
                    : 'Loading ...'}
            </Fragment>
        );
    }
}